import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type FAQItemProps = {
  question: string;
  answer: string;
};
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#F5F7FA] border-opacity-10" data-id="element-193">
      <button className="flex w-full items-center justify-between py-6 text-left" onClick={() => setIsOpen(!isOpen)} data-id="element-194">
        <h3 className="text-lg font-medium" data-id="element-195">{question}</h3>
        <ChevronDownIcon className={`h-5 w-5 text-[#F5F7FA] text-opacity-60 transition-transform ${isOpen ? 'rotate-180 transform' : ''}`} data-id="element-196" />
      </button>
      {isOpen && <div className="pb-6" data-id="element-197">
          <p className="text-[#F5F7FA] text-opacity-80" data-id="element-198">{answer}</p>
        </div>}
    </div>;
}
export function FAQ() {
  return <section className="w-full py-16 px-6 md:px-12" data-id="element-199">
      <div className="max-w-4xl mx-auto" data-id="element-200">
        <h2 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-201">
          Frequently Asked Questions
        </h2>
        <p className="text-lg text-[#F5F7FA] text-opacity-80 text-center mb-12 max-w-2xl mx-auto" data-id="element-202">
          Discover quick and comprehensive answers to common questions about our
          platform, services, and features.
        </p>
        <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-8" data-id="element-203">
          <FAQItem question="What does this service do?" answer="Briix uses AI to automatically prepare for your meetings by analyzing your calendar events and relevant communications. It generates concise meeting briefs with attendee research, business insights, and key discussion points so you can enter every meeting fully prepared." data-id="element-204" />
          <FAQItem question="How secure is my data?" answer="Your security is our top priority. We use enterprise-grade encryption for all data, maintain SOC 2 compliance, and never store your actual email content. We only process the metadata needed to generate meeting briefs, and you can delete your data at any time." data-id="element-205" />
          <FAQItem question="Can I choose which emails to summarize?" answer="Yes, you have complete control. You can select specific calendars to connect, exclude certain meeting types, and manually trigger briefs for only the meetings you want. Our smart filters also help prioritize relevant communications while ignoring noise." data-id="element-206" />
          <FAQItem question="What AI model do you use?" answer="We use a combination of proprietary and industry-leading language models optimized specifically for meeting preparation. Our hybrid approach combines the strengths of different models to deliver the most accurate, relevant, and insightful meeting briefs possible." data-id="element-207" />
          <FAQItem question="Can I delete my data?" answer="Absolutely. You can delete your account and all associated data at any time through your account settings. We also provide options to purge specific meeting data while maintaining your account. Upon deletion, all your data is permanently removed from our systems." data-id="element-208" />
        </div>
        <p className="text-center text-[#F5F7FA] text-opacity-80 mt-8" data-id="element-209">
          Can't find what you're looking for? Contact our{' '}
          <a href="#" className="text-[#C8F169] hover:underline" data-id="element-210">
            customer support team
          </a>
        </p>
      </div>
    </section>;
}